import axios from 'axios';

export const getFileBlobFromURL = async (url: string): Promise<Blob> => {
  const response = await axios.get(url, { responseType: 'blob' });
  return response.data;
};
